export const PAGE = {
  siblingCount: 1,
  pageSize: 5,
};

export const DOTS = "...";
